module.exports = __webpack_public_path__ + "img/9-22.afbc3945.jpg";